module.exports = __webpack_public_path__ + "static/img/short21.c999cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/short21.png
// module id = y/jB
// module chunks = 0